// extracted by mini-css-extract-plugin
module.exports = {"section":"section-style-module--section--3Y31E","black":"section-style-module--black--2frq0","productSelection":"section-style-module--productSelection--goopb"};